import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import * as RolesActions from './roles.actions';
import { RoleService } from '@app/features/users/services/role.service';

@Injectable()
export class RolesEffects {
  constructor(
    private actions$: Actions,
    private roleService: RoleService,
  ) {}

  loadRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolesActions.loadRoles),
      mergeMap(() =>
        this.roleService.getRoles().pipe(
          map((roles) => RolesActions.loadRolesSuccess({ roles })),
          catchError((error) => of(RolesActions.loadRolesFailure({ error: error.message }))),
        ),
      ),
    ),
  );
}
